import { UIHeading3 } from '@cian/ui-kit';
import * as React from 'react';
import * as styles from './styles.css';
import { formatPhoneWithSpecialChars } from '../../utils/formatString';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TitleAgreement(_ref) {
  var viewData = _ref.viewData;
  var content = React.useMemo(function () {
    if (viewData.phone) {
      return {
        title: /*#__PURE__*/_jsx("span", {
          children: "\u0421\u043E\u0437\u0434\u0430\u0451\u043C \u043D\u043E\u0432\u044B\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u043D\u0430\xA0\u043D\u043E\u043C\u0435\u0440"
        }),
        subTitle: "".concat(formatPhoneWithSpecialChars(viewData.phone))
      };
    } else if (viewData.email) {
      return {
        title: /*#__PURE__*/_jsx("span", {
          children: "\u0421\u043E\u0437\u0434\u0430\u0451\u043C \u043D\u043E\u0432\u044B\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u043D\u0430\xA0\u043F\u043E\u0447\u0442\u0443"
        }),
        subTitle: "".concat(viewData.email)
      };
    } else {
      return {
        title: /*#__PURE__*/_jsx("span", {
          children: "\u0421\u043E\u0437\u0434\u0430\u0451\u043C \u043D\u043E\u0432\u044B\u0439 \u0430\u043A\u043A\u0430\u0443\u043D\u0442"
        })
      };
    }
  }, [viewData]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles['title'],
    children: [/*#__PURE__*/_jsx(UIHeading3, {
      children: content.title
    }), content.subTitle && /*#__PURE__*/_jsx("span", {
      className: styles['subtitle'],
      children: content.subTitle
    })]
  });
}